<template>
  <div class="container-xs">
    <h2 class="title">My Xsensible community</h2>
    <p class="subtitle">
      Already have an account? Enter your email and password to login to your
      account.
    </p>
    <form class="form-box" @submit.prevent="login">
      <div class="form-control">
        <input
          v-model="email"
          type="email"
          required
          id="email"
          ref="email"
          placeholder="Emailadres"
        />
        <label for="email">Emailadres</label>
      </div>
      <div class="form-control">
        <input
          :type="showPassword ? 'text' : 'password'"
          v-model="password"
          required
          id="password"
          ref="password"
          placeholder="Password"
        />
        <label for="password">Password</label>
        <img
          alt="Eye icon"
          :src="passwordIcon"
          class="show-password"
          @click="showPassword = !showPassword"
        />
      </div>
      <div class="error" v-show="$store.state.errorMessage">
        {{ $store.state.errorMessage }}
      </div>
      <button type="submit" class="btn btn-black btn-full">
        <Loader v-if="$store.state.isLoading" />
        {{ $store.state.isLoading ? '' : 'Log in' }}
      </button>
      <div class="forgot-password">
        <a
          href="https://www.xsensible.com/english/my-account/login.html"
          target="_blank"
        >
          Forgot password
        </a>
      </div>
    </form>
    <div style="margin-top: 41px;">
      <h2 class="title">Xsensible community</h2>
      <p class="subtitle">
        Turn your passion for walking into real rewards. Join our loyalty
        program for free today to begin earning and redeeming exclusive offers.
      </p>
    </div>
    <router-link to="signup" class="btn btn-black btn-full">
      Sign up
    </router-link>
  </div>
</template>

<script>
import Loader from '@/components/Loader'
export default {
  name: 'Login',
  components: { Loader },
  data() {
    return {
      email: '',
      password: '',
      showPassword: false
    }
  },
  computed: {
    passwordIcon() {
      return this.showPassword
        ? require('../assets/icons/eye-off.svg')
        : require('../assets/icons/eye.svg')
    }
  },
  methods: {
    login() {
      this.$store
        .dispatch('login', {
          email: this.email,
          password: this.password
        })
        .then(() => this.$router.push('step-1'))
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/forms.scss';
</style>
